import React from 'react';
import { Controller } from 'react-hook-form';

import { MezzaFormField, MezzaFormFieldProps } from '../MezzaForm';
import { inputLabels } from '../../../data/labels';
import Input from '../../Input/Input';

const Street = ({ control, formState }: MezzaFormFieldProps) => {
  return (
    <Controller
      control={control}
      name={MezzaFormField.STREET}
      rules={{ required: 'Kötelező mező!' }}
      render={({ field }) => (
        <Input
          id={MezzaFormField.STREET}
          value={field.value}
          setValue={field.onChange}
          label={inputLabels.streetName}
          error={
            formState.errors[MezzaFormField.STREET]?.message
              ? `${formState.errors[MezzaFormField.STREET]?.message}`
              : ''
          }
        />
      )}
    />
  );
};

export default React.memo(Street);
